// DS: C35M
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PublishedTime from '../_partials/PublishedTime';
import WatchButton from './WatchButton';
import SubscribeButton from './SubscribeButton';
import BackButton from './BackButton';
import RootLayout from './RootLayout';
import UserInfoBlock from './UserInfoBlock';
import MoreButton from './MoreButton';
import s from './MobileSubmissionDetailsHeader.scss';
var MobileSubmissionDetailsHeader = function (_a) {
    var _b, _c;
    var currentItem = _a.currentItem, isOwner = _a.isOwner, parent = _a.parent, _d = _a.isSticky, isSticky = _d === void 0 ? true : _d, isStuck = _a.isStuck;
    var publishedTime = currentItem === null || currentItem === void 0 ? void 0 : currentItem.publishedTime;
    var isEllipsisHeaderFlagEnabled = useFlag('dev_page_ellipsis_header');
    var showStageMsPromo = ((_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.extended) === null || _b === void 0 ? void 0 : _b.showStageMonetizationPromo) === 'tier' ||
        (isEllipsisHeaderFlagEnabled &&
            (currentItem === null || currentItem === void 0 ? void 0 : currentItem.primaryTier) &&
            !((_c = currentItem.primaryTier.tier) === null || _c === void 0 ? void 0 : _c.isUserSubscribed));
    var author = currentItem === null || currentItem === void 0 ? void 0 : currentItem.author;
    return (React.createElement(RootLayout, { className: classnames(s['root'], isSticky && s['sticky'], isStuck && s['stuck'], showStageMsPromo && s['ms-promo']), prefix: parent && React.createElement(BackButton, null), left: React.createElement(React.Fragment, null,
            author && (React.createElement(UserInfoBlock, { user: author, publishedTime: publishedTime, shouldShowStageMsPromo: showStageMsPromo })),
            !author && publishedTime && (React.createElement(PublishedTime, { publishedTime: publishedTime, withoutText: true }))), right: React.createElement(React.Fragment, null,
            showStageMsPromo && !isOwner && author && (React.createElement(SubscribeButton, { user: author, relevantDeviation: currentItem })),
            !showStageMsPromo && !isOwner && author && (React.createElement(WatchButton, { user: author })),
            isEllipsisHeaderFlagEnabled && currentItem && (React.createElement(MoreButton, { deviation: currentItem }))) }));
};
MobileSubmissionDetailsHeader.displayName = 'MobileSubmissionDetailsHeader';
export default MobileSubmissionDetailsHeader;
//# sourceMappingURL=MobileSubmissionDetailsHeader.js.map